import _ from 'lodash';

import { 
  OPERATION_ADD,
  OPERATION_REMOVE,
  OPERATION_REPLACE, } from 'constants/constants' ;

export function headersForAuth(userState, getState) {
  if(!userState && !getState) 
    return null;
  userState = userState ? userState : getState().entities.currentUser;
  return {
    "X-Auth-User": userState.user_id,
    "X-Auth-Token": userState.token,
  };
}


export function createAction(action) {
  return dispatch => {
    dispatch(action);  
    return Promise.resolve();
  }
}

export function entity_reducer(entities = {}, new_entities, id_key = 'id', entity_action = OPERATION_ADD ) {
  if (new_entities == undefined || new_entities.length == 0)
    return entities;

  if(entity_action === OPERATION_ADD) {
    return _.assign({}, entities, _.keyBy(new_entities, id_key));
  } else if(entity_action === OPERATION_REMOVE) {
    let ids = _.map(new_entities, id_key);
    return _.keyBy(_.reject(entities, e => _.includes(ids, e[id_key])), id_key);
  }
}


const listSpec = {
    list: [],
    entity_type: null,
    last_updated: 0,
}

export function list_with_operation(list_state, ids, operation = OPERATION_ADD) {
  var list;
  if(operation === OPERATION_ADD) {
    list = _.union(list_state.list, ids);
  } else if(operation == OPERATION_REMOVE) {
    list = _.without(list_state.list, ...ids);
  } else if(operation == OPERATION_REPLACE) {
    list = _.clone(ids);
  }
  return _.assign({}, list_state, {list});
}

// Creates a list from a set of ID's without reducing from objects
export function list_from_ids(ids, entity_type, entity_id = 'id') {
  return {
    list: ids,
    entity_type,
    entity_id,
    last_updated: 0,
  }
}


// Lis reducer for a particular key
export function list_reducer_for_index(state = listSpec, new_entities, entity_type, entity_id = 'id', entity_action = OPERATION_ADD) {
  var list = state ? state.list : [];
  var newList;

  if(entity_action === OPERATION_ADD) {
    newList = _(new_entities)
    .map(entity_id)
    .union(list)
    .value();
  } else if (entity_action === OPERATION_REMOVE) {
    newList = _.without(list, ..._.map(new_entities, entity_id));
  }
  else if(entity_action == OPERATION_REPLACE) {
    newList = _.map(new_entities, entity_id);
  }
  return {
    list: newList,
    entity_type:entity_type,
    entity_id: entity_id,
    last_updated: 0,
  }
}

// Standard list reducer, creating keys to store each list in
export function list_reducer(state, new_entities, entity_type, indexed_by, entity_action = OPERATION_ADD, entity_id = 'id') {
    // var indices = _.map(new_entities, indexed_by);
    var grouped = _.groupBy(new_entities, _.isFunction(indexed_by) ? indexed_by : entity => entity[indexed_by]);
    var grouped_lists = _.mapValues(grouped, (entities, key) => list_reducer_for_index(state[key], entities, entity_type, entity_id, entity_action));
    return _.assign({}, state, grouped_lists);
}

// Remvoes all found elements from the lsit
export function list_remove(state, ids) {
    ids = _.castArray(ids);
    if (_.isNil(ids) || ids.length === 0)
      return state;

    return _.merge({}, state, ..._.map(state, (v,k) => {
      return { [k]: _.assign({}, v, { list: _.pull(v.list, ids) }) }
    }));
}

// Reduces list with a filter function
export function list_reducer_filtered(list, new_entities, entitiy_type, filter_func, entity_id = 'id', entity_action = OPERATION_ADD) {
  if (new_entities == undefined || new_entities.length == 0)
    return list;
  var filtered_entities = filter_func ? _.filter(new_entities, filter_func) : new_entities;
  return list_reducer_for_index(list, filtered_entities, entity_type, entity_id, entity_action);
}

// Reduces list with filter and sort function
export function list_reducer_filtered_sorted(state, new_entities, entity_type, filter_func, sort_func, map_func, entity_action = OPERATION_ADD) {
  if (new_entities == undefined || new_entities.length == 0)
    return state;
  var sorted_list = state ? state.sorted_list : [];
  var filtered_list = filter_func ? _.filter(new_entities, filter_func) : new_entities;
  var mapped_list = _.map(filtered_list, entity => ({value: map_func(entity), sort: sort_func(entity)}));

  var newList;
  var newSortedList;
  if(entity_action === OPERATION_ADD) {
    // first remove any updated entities from old sorted_list
    // might have been filtered out with updated entity data
    var new_entities_list = _.map(new_entities, entity => ({value: map_func(entity)}));
    var new_entities_dict = _.keyBy(new_entities_list, 'value');
    sorted_list = _.filter(sorted_list, item => !(item.value in new_entities_dict));
    // union old sorted_list with new filtered mapped entities list
    var unioned_list = _(sorted_list)
    .union(mapped_list)
    .value();
    // sort based on sort order desc
    newSortedList = _.orderBy(unioned_list, ["sort"], ["desc"]);
  } else if (entity_action === OPERATION_REMOVE) {
    var mapped_dict = _.keyBy(mapped_list, 'value');
    sorted_list = _.filter(sorted_list, item => !(item.value in mapped_dict));
    newSortedList = _.orderBy(sorted_list, ["sort"], ["desc"]);
  } else if (entity_action === OPERATION_REPLACE) {
    var mapped_dict = _.keyBy(mapped_list, 'value');
    newSortedList = _.orderBy(mapped_dict, ["sort"], ["desc"]);
  }
  // create list of values (ids) only.  save sorted_list for next update to resort
  newList = _.map(newSortedList, item => item.value);
  return _.assign({}, state, {
    list: newList,
    sorted_list: newSortedList,
    entity_type: entity_type,
    last_updated: 0
  });
}

export const defaultKeyValue = entity => entity['id'];

export const update_list_from_entities = (state, path, entities, key = 'id') => {
  var list_state = _.get(state, path);
  if(_.some(entities, e => _.includes(_.get(list_state, 'list'), e[key]))){
    list_state = _.clone(list_state)
    state = _.assign({}, state);
    _.set(state, path, list_state);
  }
  return state;
}

export function inheritBaseEntity(subEnt, baseEnt) {
  let newEntityClass = _.merge({}, subEnt, baseEnt);
  newEntityClass.entityReducer = (state = spec, type, body, action) => {
    let s = subEnt.entityReducer(state,type,body,action);
    if(state === s) {
      s = baseEnt.entityReducer(state,type,body,action);
    }
    return s;
  }
  return newEntityClass;
}